export const dummyPortfolios = [
    {
        id: "enterprise-reporting-platform",
        title: "Enterprise Reporting & Analytics Platform",
        description:
            "A cloud-based reporting and analytics platform designed to process and visualize large-scale operational data. Built using .NET backend services and React frontend, the system integrates with Snowflake for high-performance data querying and supports dynamic report generation. Deployed within an Azure production environment with scalable API architecture and optimized query handling.",
        type: "Enterprise Web Application",
        github: null,
        previewLink: null,
        images: [],
        keyFeatures: [
            {
                id: "erp-1",
                description: "Snowflake data warehouse integration",
            },
            {
                id: "erp-2",
                description: "Drag-and-drop dynamic report builder",
            },
            {
                id: "erp-3",
                description: "Interactive data visualization dashboard",
            },
            { id: "erp-4", description: "Scalable REST API architecture" },
            { id: "erp-5", description: "Azure cloud deployment" },
            {
                id: "erp-6",
                description: "Performance optimization for large datasets",
            },
        ],
        technologies: [
            { id: "t1", name: "FastAPI" },
            { id: "t3", name: "React" },
            { id: "t4", name: "Snowflake" },
            { id: "t5", name: "Azure" },
            { id: "t6", name: "REST API" },
        ],
    },
    {
        id: "church-scheduling-system",
        title: "Role-Based Scheduling & Volunteer Management System",
        description:
            "A full-stack scheduling platform built to manage volunteer roles, service schedules, and operational coordination. The system includes authentication, role-based access control, Google Calendar synchronization, and automated email notifications. Built with production-ready deployment practices and CI/CD pipeline integration.",
        type: "Full-Stack Web Application",
        github: null,
        previewLink: null,
        images: [],
        keyFeatures: [
            { id: "css-1", description: "Role-based access control (RBAC)" },
            { id: "css-2", description: "Google Calendar synchronization" },
            { id: "css-3", description: "Automated email notifications" },
            { id: "css-4", description: "CI/CD deployment pipeline" },
            { id: "css-5", description: "Production environment deployment" },
        ],
        technologies: [
            { id: "t7", name: "Node.js" },
            { id: "t9", name: "React" },
            { id: "t10", name: "SQL Server" },
            { id: "t11", name: "Azure" },
        ],
    },
    {
        id: "travel-itinerary-platform",
        title: "Travel Itinerary Management Platform",
        description:
            "A full-stack web application designed to manage multi-day travel planning, budgeting, and scheduling. Led end-to-end development from requirement gathering to production release, including database design, REST API architecture, and frontend implementation.",
        type: "Full-Stack Web Application",
        github: null,
        previewLink: null,
        images: [],
        keyFeatures: [
            { id: "tip-1", description: "Multi-day itinerary scheduling" },
            { id: "tip-2", description: "Budget tracking system" },
            { id: "tip-3", description: "Map integration" },
            { id: "tip-4", description: "RESTful API architecture" },
            { id: "tip-5", description: "Relational database modeling" },
        ],
        technologies: [
            { id: "t12", name: "Laravel" },
            { id: "t14", name: "Google Maps API" },
            { id: "t15", name: "SQL Server" },
        ],
    },
    {
        id: "azure-devops-monitoring",
        title: "Azure DevOps Monitoring Dashboard",
        description:
            "A real-time monitoring dashboard displaying CI/CD pipelines, pull requests, and task tracking based on Azure environments. Designed to improve engineering visibility and team productivity through centralized DevOps tracking.",
        type: "DevOps Monitoring System",
        github: null,
        previewLink: "https://itdivdevops.natanaelgeraldo.com/",
        images: [],
        keyFeatures: [
            { id: "adm-1", description: "CI/CD pipeline monitoring" },
            { id: "adm-2", description: "Pull request tracking" },
            { id: "adm-3", description: "REST API integration" },
            { id: "adm-4", description: "Secure authentication system" },
        ],
        technologies: [
            { id: "t16", name: "React" },
            { id: "t17", name: "REST API" },
            { id: "t18", name: "Azure DevOps" },
        ],
    },
    {
        id: "regiapp-mern",
        title: "RegiApp – Event Management Platform (MERN)",
        description:
            "A full-stack event management and booking platform built using the MERN stack. Includes user authentication, event creation and management, and booking workflows with secure backend services.",
        type: "Full-Stack Web Application",
        github: "https://github.com/NatanaelGeraldoS/RegiApp-MERN",
        previewLink: null,
        images: [],
        keyFeatures: [
            {
                id: "ra-1",
                description: "User authentication and authorization",
            },
            { id: "ra-2", description: "Event management system" },
            { id: "ra-3", description: "Booking workflow management" },
            { id: "ra-4", description: "RESTful backend architecture" },
        ],
        technologies: [
            { id: "t19", name: "MongoDB" },
            { id: "t20", name: "Express.js" },
            { id: "t21", name: "React" },
            { id: "t22", name: "Node.js" },
        ],
    },
    {
        id: "smartpot-iot-system",
        title: "SmartPot – IoT Plant Monitoring System",
        description:
            "An IoT-based monitoring system that tracks soil humidity and water levels using Arduino sensors and integrates with a web dashboard built in ASP.NET. The system provides real-time data visualization and remote monitoring capabilities for plant health management.",
        type: "IoT & Web Integration",
        github: "https://github.com/NatanaelGeraldoS/SmartPot",
        previewLink: null,
        images: [],
        keyFeatures: [
            {
                id: "sp-1",
                description: "Arduino-based humidity sensor monitoring",
            },
            { id: "sp-2", description: "Real-time data synchronization" },
            { id: "sp-3", description: "ASP.NET web dashboard integration" },
            { id: "sp-4", description: "Remote plant health monitoring" },
        ],
        technologies: [
            { id: "sp-t1", name: "ASP.NET" },
            { id: "sp-t2", name: "C#" },
            { id: "sp-t3", name: "Arduino" },
        ],
    },
    {
        id: "face-recognition-comparison",
        title: "Face Recognition Algorithm Comparison",
        description:
            "A Python-based analytical project comparing three different facial recognition approaches using a dataset of over 2,000 images. The project evaluates algorithm performance, accuracy metrics, and computational efficiency for real-world applicability.",
        type: "Artificial Intelligence / Data Science",
        github: "https://github.com/NatanaelGeraldoS/Face-Recognition-Comparisons",
        previewLink: null,
        images: [],
        keyFeatures: [
            {
                id: "fr-1",
                description: "Comparison of three face recognition algorithms",
            },
            {
                id: "fr-2",
                description: "Accuracy and performance benchmarking",
            },
            {
                id: "fr-3",
                description: "Dataset preprocessing and evaluation pipeline",
            },
        ],
        technologies: [
            { id: "fr-t1", name: "Python" },
            { id: "fr-t2", name: "NumPy" },
            { id: "fr-t3", name: "OpenCV" },
        ],
    },
    {
        id: "pokemon-graphql-platform",
        title: "Pokemon GraphQL Explorer",
        description:
            "A modern React-based web application integrated with GraphQL and Apollo Client to dynamically fetch and display Pokémon data. The project demonstrates advanced frontend architecture patterns and efficient data querying strategies.",
        type: "Modern Frontend Application",
        github: "https://github.com/NatanaelGeraldoS/pokemongraphql",
        previewLink: "https://pokemongraphql.natanaelgeraldo.com/",
        images: [],
        keyFeatures: [
            {
                id: "pg-1",
                description: "GraphQL integration with Apollo Client",
            },
            { id: "pg-2", description: "Dynamic search functionality" },
            { id: "pg-3", description: "Detailed entity data visualization" },
            {
                id: "pg-4",
                description: "State management and performance optimization",
            },
        ],
        technologies: [
            { id: "pg-t1", name: "React" },
            { id: "pg-t2", name: "GraphQL" },
            { id: "pg-t3", name: "Apollo Client" },
        ],
    },
    {
        id: "cloudpix-admin-cms",
        title: "CloudPix – Custom Portfolio CMS",
        description:
            "A custom-built admin panel designed to manage portfolio projects and certifications dynamically. Built with Express.js, React, and MySQL, the system allows real-time content updates with secure authentication and structured data management.",
        type: "Full-Stack CMS Platform",
        github: null,
        previewLink: "https://cloudpix.natanaelgeraldo.com",
        images: [],
        keyFeatures: [
            { id: "cp-1", description: "Secure authentication system" },
            { id: "cp-2", description: "Portfolio CRUD management" },
            { id: "cp-3", description: "Image upload support" },
            { id: "cp-4", description: "Real-time content updates" },
        ],
        technologies: [
            { id: "cp-t1", name: "Express.js" },
            { id: "cp-t2", name: "React" },
            { id: "cp-t3", name: "MySQL" },
        ],
    },
];

export const dummyCertifications = [];
